export const extractPlaceholders = (str) => {
  const re = /\{\{\s*([a-zA-Z0-9_\.]+)\s*\}\}/g;
  const seen = new Set();
  const out = [];
  let m;
  while ((m = re.exec(str)) !== null) {
    const key = m[1].trim();
    if (!seen.has(key)) {
      seen.add(key);
      out.push(key);
    }
  }
  return out;
};
